export const ROUTES = {
  root: '/',
  login: '/login',
  register: '/register',
  verifyEmail: (token = ':token') => `/verify-email/${token}`,
  forgotPassword: '/forgot-password',
  resetPassword: (token = ':token') => `/reset-password/${token}`,

  dashboard: '/',
  activities: '/activities',

  profile: '/me/profile',
  settings: '/me/settings',
  achievements: '/me/achievements',
  notifications: '/me/notifications',

  friends: '/friends',
  communities: '/communities',
  community: (slug = ':slug') => `/communities/${slug}`,
  leaderboards: '/leaderboards',
  challenges: '/challenges',

  publicProfile: (username = ':username') => `/u/${username}`,

  adminChallenges: '/admin/challenges',
} as const;
